const styles = (theme) => ({
  linkInfo: {
    color: theme.palette.white,
    fontWeight: 700,
    cursor: 'pointer',
  },
})

export default styles
